export default "__VITE_ASSET__BiIYzUxb__"